<template>
  <div class="video-play-container">
    <!-- 标签页切换 -->
    <div class="tab-header">
      {{ this.$t("menu_video_funscripts_player") }}
    </div>
    <div class="tab-content create-room">
      <div class="two-column-layout">
        <!-- 左侧区域 -->
        <div class="left-section">
          <div class="container">
            <video
              controls
              :src="videoUrl"
              style="width: 100%; height: 100%;"
              ref="videoPlayer"
              @timeupdate="updateTime"
              disablePictureInPicture
              controlsList="nodownload noplaybackrate"
              loop
            >
            </video>
          </div>

          <!-- 新增的脚本可视化区域 -->
          <div class="script-visualization">
            <div class="visualization-container" ref="visualizationContainer">
              <canvas ref="scriptCanvas"></canvas>
              <div class="current-time-marker" :style="markerStyle"></div>
            </div>
          </div>

        </div>

        <!-- 中间间隔 -->
        <div class="section-gap"></div>

        <div class="right-section">
          <div class="container">
            <!-- 上部分 - 文件选择 -->
            <div class="file-selection">
              <p v-if="fileName" class="file-name">
                <img src="@/assets/video/uploadSuccessful.png" class="upload-icon">
                {{ fileName }}
              </p>
              <p v-else class="file-placeholder">{{ this.$t("video_set_video_file") }}</p>
              <input
                type="file"
                accept="video/*"
                @change="handleFileChange"
                ref="fileInput"
                style="display: none"
              />
              <button @click="triggerFileInput">{{ this.$t("video_select_btn") }}</button>
            </div>

            <!-- 中部分 - 脚本文件选择 -->
            <div class="video-parameters">
              <div v-if="scriptFiles.length > 0" class="file-list">
                <ul>
                  <li v-for="(file, index) in scriptFiles" :key="index">
                    <span class="file-name">
                      <img src="@/assets/video/uploadSuccessful.png" class="upload-icon">
                      {{ file.name }}
                    </span>
                    <span></span>
                  </li>
                </ul>
              </div>
              <div v-else class="file-placeholder">
                {{ this.$t("video_set_funscript_files") }}
              </div>

              <input
                type="file"
                multiple
                accept=".funscript,.txt,.json,.mbscript"
                @change="handleScriptFileChange"
                ref="scriptFileInput"
                style="display: none"
              />
              <button @click="triggerScriptFileInput">{{ this.$t("video_select_btn") }}</button>
            </div>

            <!-- 下部分 - 偏移控制 -->
            <div class="offset-controls">
              <div class="offset-content">
                <div class="offset-row">
                  <label>{{ this.$t("video_offset_label") }}:</label>
                  <div class="offset-buttons">
                    <button @click="decreaseOffset">-</button>
                    <!--                    <span>{{ offset.toFixed(1) }}</span>-->
                    <input
                      type="text"
                      v-model.number="offset"
                      @change="validateOffset"
                      class="offset-input"
                    >
                    <button @click="increaseOffset">+</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 会员对话框 -->
    <MemberDialog :showDialog.sync="showMemberDialog" @close="closeMemberDialog" />
  </div>
</template>

<script>
import {TCodeFunScriptPlayer} from "@/tcode/TCodeFunScriptPlayer";
import * as cache from '@/utils/cache';
import * as auth from "@/api/platform/auth";
import MemberDialog from "../member/preMember";
import {findDeviceByCode, findDeviceByCodeNoToken, judgeIsMember} from "../../../api/platform/auth";
import NumSlider from "../motions/NumSlider";
import Edit from "../motions/edit";

export default {
  name: "videoPlayMain",
  components: {
    MemberDialog
  },
  data() {
    return {
      funScriptPlayer: TCodeFunScriptPlayer.getInstance(),
      HOME: "L05050S1000 L15050S1000 L25050S1000 R05050S1000 R15050S1000 R25050S1000 V00000S1000 V10000S1000 V20000S1000 V30000S1000 A05050S1000 A15050S1000 A20000S1000 A35050S1000",
      //输出串口
      outSerial: {
        isConnected: false,
        sendData: '',
        receivedData: '',
        conInfo: {},
      },
      videoUrl: null,
      fileName: '',
      offset: 0.0,
      scriptFiles: [], // 存储选择的脚本文件
      currentTime: '00:00',
      duration: '00:00',
      mapJ: new Map(),
      isPlaying: false,
      lastTime: 0,
      requestId: null,
      l0ScriptData: [], // 存储L0设备的脚本数据
      canvasWidth: 0,
      canvasHeight: 100,
      markerPosition: 0,
      l0ScriptFile: false,
      l1ScriptFile: false,
      l2ScriptFile: false,
      r0ScriptFile: false,
      r1ScriptFile: false,
      r2ScriptFile: false,
      pausedTime: 0, // 新增：存储暂停时的播放位置
      isSeeking: false, // 是否正在拖动
      lastSeekPosition: 0, // 最后记录的位置
      showMemberDialog: false,
      isMember: false, // 是否会员
      isMyDevice: false,//是否本公司设备
    }
  },
  computed: {
    markerStyle() {
      return {
        left: `${this.markerPosition}px`
      };
    }
  },
  mounted() {
    this.setupVideoListeners();
    this.$nextTick(() => {
      this.initCanvas();
    });

    // 添加 seeking 事件监听
    const video = this.$refs.videoPlayer;
    if (video) {
      video.addEventListener('seeking', this.handleSeeking);
    }

    // 监听连接状态变化
    this.$serialPort.on('connection-change', ({isConnected}) => {
      this.outSerial.isConnected = isConnected;
    });

    // 监听数据接收
    this.$serialPort.on('data-received', (data) => {
      this.outSerial.receivedData += data;
    });
  },
  beforeDestroy() {
    this.sendHome();
    //this.disconnect();
    const video = this.$refs.videoPlayer;
    if (video) {
      video.removeEventListener('seeking', this.handleSeeking);
    }
    this.cleanup();
  },
  methods: {
    setupVideoListeners() {
      const video = this.$refs.videoPlayer;
      if (!video) return;
      video.addEventListener('play', this.onVideoPlay);
      video.addEventListener('pause', this.onVideoPause);
      video.addEventListener('seeked', this.onVideoSeek);
      video.addEventListener('ended', this.onVideoEnd);
      video.addEventListener('timeupdate', this.updateTime);
    },
    validateOffset() {
      // 四舍五入到1位小数
      this.offset = Math.round(this.offset * 1000) / 1000;
      // offset改变后重新绘制脚本数据
      this.drawScriptData();
    },
    cleanup() {
      const video = this.$refs.videoPlayer;
      if (!video) return;
      video.removeEventListener('play', this.onVideoPlay);
      video.removeEventListener('pause', this.onVideoPause);
      video.removeEventListener('seeked', this.onVideoSeek);
      video.removeEventListener('ended', this.onVideoEnd);
      video.removeEventListener('timeupdate', this.updateTime);
      if (this.requestId) {
        cancelAnimationFrame(this.requestId);
      }
      this.funScriptPlayer.stop();
    },
    closeMemberDialog() {
      this.showMemberDialog = false;
    },
    checkDeviceConnected() {
      if (!this.outSerial.isConnected) {
        this.$message({type: "error", message: this.$t('motion_device_not_connected')});
        return false;
      }
      return true;
    },
    checkFileSelection() {
      if (!this.l0ScriptFile && !this.l1ScriptFile && !this.l2ScriptFile &&
        !this.r0ScriptFile && !this.r1ScriptFile && !this.r2ScriptFile) {
        this.$message({type: "error", message: this.$t("video_select_funscript_first")});
        return false;
      }
      return true;
    },
    //获取用户是否为会员
    findUserIsMember() {
      const pk_user = cache.getUserInfo().pk;
      auth.judgeIsMember(pk_user).then(res => {
        if (res.data == "Y") {
          this.isMember = true;
        }
      }).catch(error => {
      });
    },
    //获取设备是否为本公司设备
    async findDeviceIsMember() {
      //获取用户是否为会员
      this.findUserIsMember();
      if(!this.$serialPort.snCode){
        this.$serialPort.readSNCode();
      }
      await auth.findDeviceByCode(this.$serialPort.snCode).then(res => {
        if (res.data == "Y") {
          this.isMyDevice = true;
        }else{
          if(!this.isMember){
            this.showMemberDialog = true;
          }
        }
      }).catch(error => {
      });
    },
    async onVideoPlay() {
      if (!this.checkDeviceConnected()) return;
      if (!this.checkFileSelection()) return;
      await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
      if(!this.showMemberDialog) {
        const video = this.$refs.videoPlayer;
        this.isPlaying = true;
        // 如果有保存的暂停位置，则从该位置开始
        if (this.pausedTime > 0) {
          video.currentTime = this.pausedTime;
        }
        this.funScriptPlayer.setSendCommandCallback(this.send);
        this.funScriptPlayer.stop();
        this.funScriptPlayer.runScript((this.pausedTime + this.offset) * 1000, false);
        this.runScriptLoop();
      }
    },
    onVideoPause() {
      const video = this.$refs.videoPlayer;
      this.pausedTime = video.currentTime; // 保存当前播放位置
      this.isPlaying = false;
      if (this.requestId) {
        cancelAnimationFrame(this.requestId);
        this.requestId = null;
      }
      this.funScriptPlayer.stop();
    },
    onVideoSeek() {
      const video = this.$refs.videoPlayer;
      if (!video) return;

      this.isSeeking = false;
      const seekTime = video.currentTime;

      // 更新可视化
      this.updateVisualization(seekTime);

      // 如果视频正在播放，从新位置恢复播放
      if (!video.paused) {
        this.funScriptPlayer.setSendCommandCallback(this.send);
        this.funScriptPlayer.runScript((seekTime + this.offset) * 1000, false);
      }

      // 更新暂停位置
      this.pausedTime = seekTime;
    },
    onVideoEnd() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.currentTime = 0; // 重置到开始
        video.play().catch(error => {
          console.error("自动播放失败:", error);
        });
      }
      this.onVideoPause();
    },
    async send(data) {
      if (data.trim()) {
        try {
          console.log("---------send:", data)
          await this.$serialPort.send(data);
        } catch (error) {
        }
      }
    },

    runScriptLoop() {
      if (!this.isPlaying || this.isSeeking) return;

      const video = this.$refs.videoPlayer;
      if (!video) return;

      const currentTime = video.currentTime;

      // 只有当时间确实变化时才更新
      if (currentTime !== this.lastTime) {
        this.lastTime = currentTime;
        this.updateScriptPosition(currentTime);
        this.updateVisualization(currentTime);
      }

      this.requestId = requestAnimationFrame(this.runScriptLoop);
    },

    updateScriptPosition() {
      const video = this.$refs.videoPlayer;
      if (!video) return;

      const currentTime = video.currentTime;
      this.lastTime = currentTime;
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return

      // 清除之前选择的脚本文件和相关数据
      this.scriptFiles = [];
      this.mapJ = new Map();
      this.l0ScriptData = [];
      this.l0ScriptFile = false;
      this.l1ScriptFile = false;
      this.l2ScriptFile = false;
      this.r0ScriptFile = false;
      this.r1ScriptFile = false;
      this.r2ScriptFile = false;
      this.funScriptPlayer.stop();

      // 显式调用 drawScriptData 来清空画布
      this.$nextTick(() => {
        this.drawScriptData();
      });

      this.fileName = file.name
      this.videoUrl = URL.createObjectURL(file)
      const video = this.$refs.videoPlayer;
      video.src = this.videoUrl;
      // 重置暂停位置
      this.pausedTime = 0;

      // 当元数据加载完成后获取视频时长
      video.onloadedmetadata = () => {
        this.duration = this.formatTime(video.duration);
      };
      this.$once('hook:beforeDestroy', () => {
        URL.revokeObjectURL(this.videoUrl)
      })
    },
    sendHome() {
      this.send(this.HOME)
    },
    // 更新时间显示
    updateTime() {
      const video = this.$refs.videoPlayer;
      if (!video) return;

      this.currentTime = this.formatTime(video.currentTime);
      this.updateTimeMarker(video.currentTime);
      this.updateVisualization(video.currentTime);

      // 如果正在拖动，记录实时位置
      if (this.isSeeking) {
        this.lastSeekPosition = video.currentTime;
        console.log("实时拖动位置:", this.lastSeekPosition);
      }
    },
    increaseOffset() {
      this.offset = parseFloat((this.offset + 0.1).toFixed(3));
    },
    decreaseOffset() {
      this.offset = parseFloat((this.offset - 0.1).toFixed(3));
    },
    selectParameters() {
      // 参数选择逻辑
    },
    triggerScriptFileInput() {
      // 先检查是否已选择视频文件
      if (!this.videoUrl) {
        this.$message({
          type: "error",
          message: this.$t("video_select_video_first")
        });
        event.target.value = null; // 清空文件选择
        return;
      }
      this.$refs.scriptFileInput.click()
    },

    xorCrypt(str, key) {
      let result = '';
      const keyLength = key.length;
      for (let i = 0; i < str.length; i++) {
        const keyChar = key.charCodeAt(i % keyLength);
        const strChar = str.charCodeAt(i);
        result += String.fromCharCode(strChar ^ keyChar);
      }
      // console.log(result)
      return result;
    },

    decrypt(encryptedText, key) {
      const decoded = decodeURIComponent(escape(atob(encryptedText)));
      console.log(decoded);
      return this.xorCrypt(decoded, key);
    },

    async handleScriptFileChange(event) {
      const files = Array.from(event.target.files)
      if (!files.length) return
      // 添加新文件到列表
      for (const file of files) {
        if (!this.scriptFiles.some(f => f.name === file.name)) {
          this.scriptFiles.push(file)
          const content = await this.readFileContent(file);
          let name = "L0";
          if (file.name.endsWith(".sway.funscript") || file.name.endsWith(".sway.mbscript")) {
            name = "L2";
            this.l2ScriptFile = true;
          } else if (file.name.endsWith(".surge.funscript") || file.name.endsWith(".surge.mbscript")) {
            name = "L1";
            this.l1ScriptFile = true;
          } else if (file.name.endsWith(".roll.funscript") || file.name.endsWith(".roll.mbscript")) {
            name = "R1";
            this.r1ScriptFile = true;
          } else if (file.name.endsWith(".pitch.funscript") || file.name.endsWith(".pitch.mbscript")) {
            name = "R2";
            this.r2ScriptFile = true;
          } else if (file.name.endsWith(".twist.funscript") || file.name.endsWith(".twist.mbscript")) {
            name = "R0";
            this.r0ScriptFile = true;
          }
          if (file.name.endsWith(".L0.funscript") || file.name.endsWith(".L0.mbscript")) {
            name = "L0";
          } else if (file.name.endsWith(".L1.funscript") || file.name.endsWith(".L1.mbscript")) {
            name = "L1";
            this.l1ScriptFile = true;
          } else if (file.name.endsWith(".L2.funscript") || file.name.endsWith(".L2.mbscript")) {
            name = "L2";
            this.l2ScriptFile = true;
          } else if (file.name.endsWith(".R0.funscript") || file.name.endsWith(".R0.mbscript")) {
            name = "R0";
            this.r0ScriptFile = true;
          } else if (file.name.endsWith(".R1.funscript") || file.name.endsWith(".R1.mbscript")) {
            name = "R1";
            this.r1ScriptFile = true;
          } else if (file.name.endsWith(".R2.funscript") || file.name.endsWith(".R2.mbscript")) {
            name = "R2";
            this.r2ScriptFile = true;
          }
          const jsonContent = JSON.parse(content);
          if (jsonContent.mb == 'V2') {
            console.log(jsonContent.actionData);
            const res = this.decrypt(jsonContent.actionData, 'mdfuntion')
            // console.log("=============");
            jsonContent.actions = JSON.parse(res);
            jsonContent.actionData = '';
            console.log(jsonContent);
          }
          this.mapJ.set(name, jsonContent);
          // 如果是L0设备，保存数据用于可视化
          if (name === 'L0') {
            this.l0ScriptFile = true;
            this.l0ScriptData = jsonContent.actions || [];
            this.$nextTick(() => {
              this.drawScriptData();
            });
          }
        }
      }
      this.funScriptPlayer.addScript(this.mapJ, 1, 10)
      // 重置input值，允许重复选择相同文件
      event.target.value = null
    },


    removeScriptFile(index) {
      this.scriptFiles.splice(index, 1)
    },
    // 读取文件内容
    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
          resolve(event.target.result);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        // 根据文件类型选择读取方式
        if (file.type.includes('json') || file.name.endsWith('.funscript') || file.name.endsWith('.mbscript')) {
          reader.readAsText(file);
        } else {
          reader.readAsText(file);
        }
      });
    },


    // 格式化时间为 MM:SS
    formatTime(seconds) {
      const date = new Date(0);
      date.setSeconds(seconds);
      const timeString = date.toISOString().substr(11, 8);
      return timeString.startsWith('00:') ? timeString.substr(3) : timeString;
    },

    // 初始化画布
    initCanvas() {
      const container = this.$refs.visualizationContainer;
      if (!container) return;

      this.canvasWidth = container.clientWidth;
      this.drawScriptData();
    },

    // 绘制脚本数据
    drawScriptData() {
      const canvas = this.$refs.scriptCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 如果没有脚本数据，只绘制背景并返回
      if (!this.l0ScriptData.length) {
        // 绘制背景
        ctx.fillStyle = '#f5f5f5';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        return;
      }

      const video = this.$refs.videoPlayer;

      let currentTime = this.isSeeking ? this.lastSeekPosition : (video ? video.currentTime : 0);
      currentTime += this.offset;

      canvas.width = this.canvasWidth;
      canvas.height = this.canvasHeight;

      // 计算时间比例（考虑offset）
      const duration = this.getScriptDuration() / 1000; // 转换为秒
      const timeScale = duration > 0 ? this.canvasWidth / duration : 0;

      // 绘制背景
      ctx.fillStyle = '#f5f5f5';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 分割已完成和未完成部分（考虑offset）
      const completedActions = this.l0ScriptData.filter(action =>
        (action.at / 1000) <= currentTime && (action.at / 1000) >= this.offset
      );
      const upcomingActions = this.l0ScriptData.filter(action =>
        (action.at / 1000) > currentTime && (action.at / 1000) >= this.offset
      );

      // 绘制已完成部分的红色线（考虑offset）
      if (completedActions.length > 0) {
        ctx.strokeStyle = '#ff0000';
        ctx.lineWidth = 2;
        ctx.beginPath();

        const firstAction = completedActions[0];
        ctx.moveTo(
          ((firstAction.at / 1000) - this.offset) * timeScale,
          canvas.height - (firstAction.pos / 100 * canvas.height)
        );

        for (let i = 1; i < completedActions.length; i++) {
          const action = completedActions[i];
          ctx.lineTo(
            ((action.at / 1000) - this.offset) * timeScale,
            canvas.height - (action.pos / 100 * canvas.height)
          );
        }
        ctx.stroke();
      }

      // 绘制未完成部分的蓝色线（考虑offset）
      if (upcomingActions.length > 0) {
        ctx.strokeStyle = '#4285f4';
        ctx.lineWidth = 2;
        ctx.beginPath();

        const lastCompleted = completedActions[completedActions.length - 1];
        if (lastCompleted) {
          ctx.moveTo(
            ((lastCompleted.at / 1000) - this.offset) * timeScale,
            canvas.height - (lastCompleted.pos / 100 * canvas.height)
          );
        } else {
          const firstUpcoming = upcomingActions[0];
          if (firstUpcoming) {
            ctx.moveTo(
              ((firstUpcoming.at / 1000) - this.offset) * timeScale,
              canvas.height - (firstUpcoming.pos / 100 * canvas.height)
            );
          }
        }

        for (let i = 0; i < upcomingActions.length; i++) {
          const action = upcomingActions[i];
          ctx.lineTo(
            ((action.at / 1000) - this.offset) * timeScale,
            canvas.height - (action.pos / 100 * canvas.height)
          );
        }
        ctx.stroke();
      }

      // 更新当前时间标记（考虑offset）
      this.updateTimeMarker(currentTime);

      // 更新当前时间标记（考虑offset）
      //const adjustedCurrentTime = Math.max(0, currentTime + this.offset);
      const adjustedCurrentTime = Math.min(duration, Math.max(0, currentTime + this.offset));
      this.markerPosition = adjustedCurrentTime * timeScale;
    },

    // 获取脚本总时长
    getScriptDuration() {
      if (!this.l0ScriptData.length) return 0;
      // 返回考虑offset后的有效时长（毫秒）
      const rawDuration = this.l0ScriptData[this.l0ScriptData.length - 1].at;
      return Math.max(0, rawDuration - this.offset * 1000);
    },

    // 更新当前时间标记
    updateTimeMarker(currentTime) {
      const duration = this.getScriptDuration();
      if (duration > 0) {
        this.markerPosition = (currentTime / duration) * this.canvasWidth;
      }
    },
    // 新增：更新可视化
    updateVisualization(currentTime) {
      if (!this.l0ScriptData.length) return;

      // 考虑是否正在拖动
      const effectiveTime = this.isSeeking ? this.lastSeekPosition : currentTime;
      const adjustedTime = Math.max(0, effectiveTime + this.offset);

      const duration = this.getScriptDuration() / 1000;
      if (duration > 0) {
        const progress = Math.min(1, adjustedTime / duration);
        this.markerPosition = progress * this.canvasWidth;
        this.drawScriptData();
      }
    },

    // 高亮当前动作点
    highlightCurrentAction(currentTime) {
      const canvas = this.$refs.scriptCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const duration = this.getScriptDuration();
      const timeScale = this.canvasWidth / duration;

      // 找到当前时间点最近的动作
      const currentAction = this.findClosestAction(currentTime);
      if (currentAction) {
        const x = (currentAction.at / 1000) * timeScale;
        const y = canvas.height - (currentAction.pos / 100 * canvas.height);

        // 绘制高亮点
        // ctx.fillStyle = '#ff0000';
        // ctx.beginPath();
        // ctx.arc(x, y, 5, 0, Math.PI * 2);
        // ctx.fill();

        // // 绘制数值标签
        // ctx.fillStyle = '#000';
        // ctx.font = '12px Arial';
        // ctx.fillText(`${currentAction.pos}%`, x + 8, y - 8);
      }
    },

    // 新增：查找最近的动作点
    findClosestAction(currentTime) {
      if (!this.l0ScriptData.length) return null;

      let closestAction = this.l0ScriptData[0];
      let minDiff = Math.abs(currentTime - (closestAction.at / 1000));

      for (let i = 1; i < this.l0ScriptData.length; i++) {
        const diff = Math.abs(currentTime - (this.l0ScriptData[i].at / 1000));
        if (diff < minDiff) {
          minDiff = diff;
          closestAction = this.l0ScriptData[i];
        }
      }

      return closestAction;
    },
    async disconnect() {
      try {
        if (this.outSerial.isConnected) {
          await this.$serialPort.disconnect();
        }
      } catch (error) {
        console.error('Disconnecting failed:', error);
      }
    },
    handleSeeking() {
      // 处理 seeking 事件，确保进度条可以自由拖动
      //const video = this.$refs.videoPlayer;
      // if (!video) return;

      // 更新当前时间显示
      //this.updateVisualization(video.currentTime);
      this.isSeeking = true;
      this.funScriptPlayer.stop();// 暂停脚本播放但不重置位置
    },
  },
  created: function () {
    this.outSerial.conInfo = this.$serialPort.getPortInfo();
    if (this.outSerial.conInfo.isConnected == true) {
      this.outSerial.isConnected = true;
    } else {
      this.outSerial.isConnected = false;
    }
  },
}
</script>

<style scoped>
.video-play-container {
  width: 100%;
  min-width: 1200px; /* 根据内容设置最小宽度 */
  height: 100%;
  overflow: auto; /* 添加滚动条 */
  padding: 20px;
  box-sizing: border-box;
}

.tab-header {
  display: inline-flex;
  margin-bottom: 15px;
  padding-bottom: 10px;
  padding-left: 15px;
  ont-family: PingFangSC-Medium;
  font-size: 17px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
}

.left-section {
  width: 690px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  height: 560px; /* 固定高度，可根据需要调整 */
}

.right-section {
  width: 500px;
  padding: 0; /* 移除内边距 */
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.tab-content {
  padding: 0 15px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.container {
  width: 100%;
  height: 450px;
  display: flex;
  flex-direction: column;
}

.two-column-layout {
  display: flex;
  width: auto;
  max-width: none;
  margin: 0;
  justify-content: flex-start;
}

.section-gap {
  width: 10px; /* 增大间隔 */
  flex-shrink: 0;
}

button {
  padding: 8px 20px; /* 增大按钮尺寸 */
  background-color: #AA81FF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin: 10px 0;
  min-width: 100px; /* 统一按钮宽度 */
}

button:hover {
  background-color: #7200D6;
}

.right-section .container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 0; /* 移除容器内边距 */
  width: 100%; /* 确保容器宽度填满 */
}

.file-selection {
  width: 100%;
  height: 100px;
  margin-bottom: 10px; /* 增加间隔 */
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.file-selection button {
  margin-top: 5px; /* 单独设置上边距 */
}
.upload-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
}

.file-name {
  font-size: 13px;
  color: #333;
  word-break: break-all;
  text-align: center;
  max-width: 100%;
}


.video-parameters {
  width: 100%;
  min-height: 350px; /* 改为min-height以适应内容 */
  margin-bottom: 10px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.video-parameters ul {
  list-style-type: none;
  padding: 0;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 15px;
}

.video-parameters li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
}

.file-list {
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 5px;
}

.file-placeholder {
  width: 100%;
  padding: 20px;
  color: #888;
  margin-bottom: 1px;
  border-radius: 4px;
  font-size: 11px;
  font-style: italic;
  text-align: center;
}

.offset-controls {
  width: 100%;
  height: 20px;
  background-color: #ebeaef;
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.offset-content {
  width: 100%;
  padding: 0;
}

.offset-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.offset-row label {
  font-size: 14px;
  color: #333;
  margin-right: 15px;
  flex-shrink: 0;
  width: 160px; /* 固定标签宽度 */
}

.offset-buttons {
  display: flex;
  align-items: center;
  margin-left: 0; /* 移除左边距 */
}

.offset-buttons button {
  padding: 5px 15px;
  margin: 0 5px;
  min-width: auto;
}

.offset-buttons span {
  display: inline-block;
  min-width: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin: 0 10px;
}

/* 新增的样式 */
.script-visualization {
  margin-top: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  background-color: white;
}

.visualization-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.visualization-container {
  position: relative;
  width: 100%;
  height: 50px;
  background-color: #f9f9f9;
  border-radius: 4px;
  overflow: hidden;
}

.visualization-container canvas {
  width: 100%;
  height: 100%;
}

.current-time-marker {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  transform: translateX(-1px);
  z-index: 10;
}

.offset-input {
  width: 60px;
  text-align: center;
  padding: 5px;
  margin: 0 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: #ebeaef;
}

/* Update the offset-buttons style to: */
.offset-buttons {
  display: flex;
  align-items: center;
  margin-left: 0;
}

.offset-input:focus {
  border: 1px solid #AA81FF;
  outline: none; /* 移除默认轮廓 */
  transition: border-color 0.3s ease; /* 添加过渡动画 */
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/videoPlay/videoPlayMain.vue